import { BASE_URL } from "../config/Constant";

export const API = [
    {
        'name': 'langauges',
        'listAPI': `${BASE_URL}languages/`,
        'languageData': `${BASE_URL}fetch_language_data/`,
    },
    {
        'name': 'faq',
        'listAPI': `${BASE_URL}faq_list/`,
    },
    {
        'name': 'cms_setting',
        'FetchDataAPI': `${BASE_URL}web_cms_setting_list_key/`,
    },
    {
        'name': 'map',
        'districtWiseCount': `${BASE_URL}district-wise-count`,
        // 'monthWiseCount': `${BASE_URL}month-wise-count`,
        // 'recentFaqs': `${BASE_URL}recent-faqs`,
        // 'dashboardCounts': `${BASE_URL}dashboard_counts`,
    },
    {
        'name': 'analytics',
        'getVisit': `${BASE_URL}analytics/visits`,
        'postVisit': `${BASE_URL}analytics/visits`,
        'health': `${BASE_URL}analytics/health`,
    },
];